import React from 'react';

const SuccessStoriesPage = () => {
  return (
    <div className="max-w-6xl mx-auto px-4 py-8">
      {/* Header Section */}
      <div className="flex justify-between items-center mb-6">
        <div>
          <h2 className="text-2xl font-bold">Success <span className="text-blue-500">Stories</span></h2>
          <p className="text-sm text-gray-600">Gain Access to Installation Wizards</p>
        </div>
        <div className="text-sm text-gray-500">
          View All Success Stories &rarr;
        </div>
      </div>

      {/* Success Stories Grid */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 mb-10">
        {/* Main Featured Story */}
        <div className="lg:col-span-2 relative overflow-hidden rounded-lg shadow-md" style={{ backgroundColor: '#1c3158' }}>
          <div className="p-6 flex flex-col justify-end h-full text-white">
            <div className="space-y-2">
              <h3 className="text-4xl font-bold text-yellow-400">A LEGACY</h3>
              <h3 className="text-xl font-medium text-yellow-400">OF</h3>
              <h3 className="text-4xl font-bold text-yellow-400">EXCELLENCE</h3>
              <p className="text-lg mt-4">INSPIRING NARRATIVE OF</p>
              <div className="inline-block bg-teal-500 text-white px-4 py-1 rounded-md text-lg font-bold">
                NAEEM ABBAS
              </div>
            </div>
          </div>
          <div className="absolute right-0 bottom-0 h-full w-1/2">
            <div className="h-full w-full flex items-end justify-end">
              <div className="h-5/6 w-full relative">
                {/* Placeholder for person image */}
                <div className="absolute bottom-0 right-0 w-full h-full">
                  <img src="/api/placeholder/300/400" alt="Naeem Abbas" className="object-cover object-bottom h-full" />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Top Right Story */}
        <div className="relative overflow-hidden rounded-lg shadow-md" style={{ backgroundColor: '#1c3158' }}>
          <div className="p-4 text-white h-48">
            <div className="text-right">
              <h3 className="text-xl font-bold text-yellow-400">STARTING FROM</h3>
              <h3 className="text-xl font-bold text-yellow-400">SCRATCH</h3>
              <p className="text-sm mt-2">THE REMARKABLE RISE OF</p>
              <div className="inline-block bg-teal-500 text-white px-3 py-1 rounded-md text-base font-bold mt-1">
                DANISH ATHER
              </div>
            </div>
            <div className="absolute top-2 right-2">
              <span className="bg-yellow-400 text-xs px-2 py-1 rounded text-gray-800 font-bold">
                #SUCCESS STORY
              </span>
            </div>
          </div>
          <div className="absolute left-0 bottom-0 h-full w-1/2">
            <div className="h-full w-full flex items-end">
              <div className="h-5/6 w-full relative">
                {/* Placeholder for person image */}
                <div className="absolute bottom-0 left-0 w-full h-full">
                  <img src="/api/placeholder/200/300" alt="Danish Ather" className="object-cover object-bottom h-full" />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Left Story */}
        <div className="relative overflow-hidden rounded-lg shadow-md" style={{ backgroundColor: '#1c3158' }}>
          <div className="p-4 text-white h-48">
            <div className="text-right">
              <h3 className="text-lg font-bold">NAVIGATING EXCELLENCE AT</h3>
              <h3 className="text-xl font-bold text-yellow-400">24-7 CONSULTANCY</h3>
              <p className="text-sm mt-2">FT. SYED SANA-UR-REHMAN</p>
            </div>
            <div className="absolute top-2 right-2">
              <span className="bg-yellow-400 text-xs px-2 py-1 rounded text-gray-800 font-bold">
                #SUCCESS STORY
              </span>
            </div>
          </div>
          <div className="absolute left-0 bottom-0 h-full w-1/2">
            <div className="h-full w-full flex items-end">
              <div className="h-5/6 w-full relative">
                {/* Placeholder for person image */}
                <div className="absolute bottom-0 left-0 w-full h-full">
                  <img src="/api/placeholder/200/300" alt="Syed Sana-Ur-Rehman" className="object-cover object-bottom h-full" />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Right Story */}
        <div className="relative overflow-hidden rounded-lg shadow-md" style={{ backgroundColor: '#1c3158' }}>
          <div className="p-4 text-white h-48">
            <div className="text-right">
              <h3 className="text-lg font-bold">HOW DID I START</h3>
              <h3 className="text-xl font-bold text-yellow-400">MY JOURNEY</h3>
              <p className="text-sm mt-2">WITH 24-7 CONSULTANCY?</p>
            </div>
            <div className="absolute top-2 right-2">
              <span className="bg-yellow-400 text-xs px-2 py-1 rounded text-gray-800 font-bold">
                #SUCCESS STORY
              </span>
            </div>
          </div>
          <div className="absolute left-0 bottom-0 h-full w-1/2">
            <div className="h-full w-full flex items-end">
              <div className="h-5/6 w-full relative">
                {/* Placeholder for person image */}
                <div className="absolute bottom-0 left-0 w-full h-full">
                  <img src="/api/placeholder/200/300" alt="Consultant" className="object-cover object-bottom h-full" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Contact Form Section */}
      <div className="flex flex-col lg:flex-row gap-6 bg-gray-100 rounded-lg p-6">
        <div className="lg:w-2/3">
          <h3 className="text-xl font-bold mb-4">Get Ready To <span className="text-blue-500">Started?</span></h3>
          
          <div className="space-y-4">
            <div className="bg-white rounded-lg p-2 border border-gray-200">
              <p className="text-sm text-gray-500 mb-1">Please select choice...</p>
              <div className="h-5"></div>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <input 
                type="text" 
                placeholder="Your name..." 
                className="w-full p-2 border border-gray-200 rounded-lg"
              />
              <input 
                type="email" 
                placeholder="Your Email..." 
                className="w-full p-2 border border-gray-200 rounded-lg"
              />
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="flex items-center">
                <div className="w-6 h-6 flex items-center justify-center bg-blue-500 text-white rounded-sm mr-2">
                  <span className="text-xs">+92</span>
                </div>
                <input 
                  type="text" 
                  placeholder="Your number..." 
                  className="w-full p-2 border border-gray-200 rounded-lg"
                />
              </div>
              <input 
                type="text" 
                placeholder="Your Subject..." 
                className="w-full p-2 border border-gray-200 rounded-lg"
              />
            </div>
            
            <textarea 
              placeholder="Project Description..." 
              className="w-full p-2 border border-gray-200 rounded-lg h-24"
            ></textarea>
            
            <button className="bg-blue-500 text-white px-4 py-2 rounded-lg inline-flex items-center">
              Submit <span className="ml-2">&rarr;</span>
            </button>
          </div>
        </div>
        
        <div className="lg:w-1/3">
          <div className="bg-white p-4 rounded-lg shadow-sm mb-4">
            <div className="flex items-center">
              <div className="w-16 h-16 bg-blue-100 rounded-lg flex items-center justify-center mr-4">
                <span className="text-2xl font-bold text-blue-500">G</span>
              </div>
              <div>
                <div className="flex items-center">
                  <span className="font-bold text-lg">4.8</span>
                  <div className="flex text-yellow-400 ml-2">
                    ★★★★★
                  </div>
                </div>
                <p className="text-xs text-gray-500">Based on 21 Google Reviews</p>
              </div>
            </div>
          </div>
          
          <div className="bg-white p-4 rounded-lg shadow-sm">
            <div className="flex items-start">
              <div className="w-10 h-10 bg-yellow-100 rounded-full flex items-center justify-center mr-3">
                <span className="text-sm">FQ</span>
              </div>
              <div>
                <p className="text-sm font-medium">Fahad Rafique</p>
                <p className="text-xs text-gray-500">Great service, one of the best, highly professional</p>
                <div className="flex text-yellow-400 mt-1">
                  ★★★★★
                </div>
              </div>
            </div>
            <div className="flex justify-end mt-2">
              <span className="text-blue-500 text-xl">•</span>
              <span className="text-blue-500 text-xl ml-1">•</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuccessStoriesPage;